import pathToRegexp from 'path-to-regexp'
import { matchPath } from 'react-router-dom'

// Utils

const makePath = (path, defaultQueryParams) => ({
  path,
  regexp: pathToRegexp(path),
  linkTo:
    defaultQueryParams === undefined
      ? pathToRegexp.compile(path)
      : params => {
          const toPath = pathToRegexp.compile(path)
          return generateQueryPath(toPath(params), defaultQueryParams)
        },
  match: (pathname, options = {}) => matchPath(pathname, { ...options, path }),
})

export const generateQueryPath = (path, queryParams) => {
  const searchStr = new URLSearchParams(queryParams).toString()
  return path + '?' + searchStr
}

const URL_PATHNAMES = {
  HOME: '/',
  SHIPPING_SEND: '/send',
  SHIPPINGS: '/shippings',
  SHIPPINGS_TRACKING: '/shippings-tracking',
  SHIPPINGS_RECORDING: '/shippings-recording',
  HELP: '/help',
  PRINT_SETTINGS: '/print-settings',
  DOWNLOADS: '/downloads',
  BILLING: '/billing',
  USER_ZONE: '/user-zone',
  AGENDA: '/agenda',
  REPORTS: '/reports',
}

export const HOME = makePath(URL_PATHNAMES.HOME)

export const SHIPPING_SEND = makePath(URL_PATHNAMES.SHIPPING_SEND)

export const SHIPPINGS = makePath(`${URL_PATHNAMES.SHIPPINGS}/:id?`)

export const SHIPPINGS_TRACKING = makePath(URL_PATHNAMES.SHIPPINGS_TRACKING)

export const SHIPPINGS_RECORDING = makePath(URL_PATHNAMES.SHIPPINGS_RECORDING)

export const SHIPPING_DETAIL = makePath(
  `${URL_PATHNAMES.SHIPPINGS_TRACKING}/:id`,
)

export const HELP = makePath(URL_PATHNAMES.HELP)

export const PRINT_SETTINGS = makePath(URL_PATHNAMES.PRINT_SETTINGS)

export const DOWNLOADS = makePath(URL_PATHNAMES.DOWNLOADS)

export const BILLING = makePath(URL_PATHNAMES.BILLING)

export const USER_ZONE = makePath(URL_PATHNAMES.USER_ZONE)

export const AGENDA = makePath(URL_PATHNAMES.AGENDA)

export const REPORTS = makePath(URL_PATHNAMES.REPORTS)

export const URL_PATHNAMES_TRANSLATION_MAP = {
  [URL_PATHNAMES.HOME]: 'home:title',
  [URL_PATHNAMES.SHIPPINGS_TRACKING]: 'shipping-tracking:title',
}
